var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4515 20.7985L17.8406 15.1875C19.1165 13.2933 19.746 10.9266 19.409 8.4047C18.8343 4.11517 15.3187 0.624389 11.0249 0.08078C4.64104 -0.727017 -0.727085 4.64111 0.0807583 11.025C0.624508 15.3206 4.11576 18.8391 8.40576 19.411C10.9276 19.7479 13.2948 19.1186 15.1886 17.8425L20.7995 23.4535C21.5317 24.1856 22.719 24.1856 23.4512 23.4535C24.1828 22.7203 24.1828 21.5297 23.4515 20.7985ZM3.70776 9.75001C3.70776 6.44158 6.39932 3.75001 9.70776 3.75001C13.0162 3.75001 15.7078 6.44158 15.7078 9.75001C15.7078 13.0585 13.0162 15.75 9.70776 15.75C6.39932 15.75 3.70776 13.0594 3.70776 9.75001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.d8464e828fbbe684934f028fd924a08d.svg";
export { ForwardRef as ReactComponent };